import * as staticImages from "./static-images";

/** VERTICAL FICZERY */

export const BIURO_RACHUNKOWE_VERTICAL_FEATURES: FeatureVerticalElementData[] = [
  {
    featureName: "INDYWIDUALNE PODEJŚCIE",
    featureDescription: [
      "Każda firma korzystająca z usług naszego biura obsługiwana jest w sposób całkowicie indywidualny. Jest to możliwe dzięki zastosowaniu zasady dedykowanego księgowego, który przypisany jest do danej firmy.",
      "Nasza współpraca nie ogranicza się jedynie do prowadzenia wymaganych przez prawo ewidencji księgowych. Dbamy o to, by nasze działania miały wartość dodaną dla klienta. Sukces klienta jest i naszym sukcesem."
    ],
    featureImage: staticImages.APPLICATION_CALCULATION_FEATURE_IMAGE
  },
  {
    featureName: "DEDYKOWANY KSIĘGOWY",
    featureDescription: [
      "Decydując się na współpracę z naszym biurem, macie Państwo możliwość bezpośredniego kontaktu ze swoim księgowym, który troszczy się o Państwa rachunkowość.",
      "Dodatkowo dedykowany księgowy utrzymuje bieżący kontakt z klientem, tak abyście mieli Państwo stały oraz łatwy dostęp do informacji na temat działalności firmy.",
      "Dzięki zastosowanemu rozwiązaniu, nasi klienci zyskują poczucie bezpieczeństwa i stabilności."
    ],
    featureImage: staticImages.CONSULTING_FEATURE_IMAGE
  },
  {
    featureName: "WYSOKIE STANDARDY",
    featureDescription: [
      "Usługi świadczone przez nas są na wysokim poziomie. Księgi rachunkowe prowadzimy rzetelnie, zgodnie z obowiązującymi przepisami ustawy o rachunkowości oraz obowiązującymi przepisami podatkowymi.",
      "Wybierając nasze biuro rachunkowe, mogą Państwo liczyć na pomoc oraz konsultacje w sprawach związanych z prowadzeniem firmy. Pracownicy biura dysponują odpowiednimi kwalifikacjami oraz są zaangażowani w swoją pracę."
    ],
    featureImage: staticImages.SUITCASE_FEATURE_IMAGE
  },
  {
    featureName: "NOWOCZESNA APLIKACJA",
    featureDescription: [
      "Współpraca z biurem rachunkowym odbywa się w oparciu o aplikację internetową Fakturomania.pl, która wliczona jest w cenę, więc nie wiąże się z dodatkowym kosztem.",
      "Aplikacja online pozwala na całodobowy podgląd bieżącej sytuacji firmy, generowanie dokumentacji oraz wystawianie faktur, dzięki czemu mają Państwo łatwy dostęp do danych."
    ],
    featureImage: staticImages.ANALYSIS_FEATURE_IMAGE
  },
  {
    featureName: "BEZPIECZEŃSTWO DANYCH",
    featureDescription: [
      "Chronimy tajemnicę przedsiębiorstwa. Szyfrowanie danych zwiększa poziom bezpieczeństwa i prywatności naszych usług. Gdy wystawiasz fakturę, przesyłasz nam dokumenty lub odpowiadasz na maila, chronimy te dane wieloma warstwami zabezpieczeń.",
      "We wszystkich naszych usługach stosujemy odpowiednie zabezpieczenia. Bezpieczna transmisja danych, bezpieczne logowanie oraz bezpieczeństwo danych to trzon wszystkich naszych usług."
    ],
    featureImage: staticImages.SECURITY_FEATURE_IMAGE
  }
];



// WEBPACK FOOTER //
// ./src/constants/features-vertical-data.ts